import CycleStatus from '../../enums/cycle-status.enum';

export const COMMON_TAB_STYLES =
  'bg-primary font-medium border border-burnt-orang hover:bg-[#ff9146] active:bg-[ff6700]';
export const ACTIVE_TAB_STYLES = 'bg-primary text-white';
export const INACTIVE_TAB_STYLES = 'bg-white text-black';

export const TAB_NUMBER = {
  INACTIVE: 0,
  ACTIVE: 1,
  COMPLETED: 2,
};

export const NO_TAB_SELECTED = -1;

export const CYCLE_TAB_BY_STATUS_QUERY_KEY = 'status';
export const DEFAULT_STATUS_TAB = CycleStatus.Active;

export const CYCLE_STATUS_TO_NUMBER: Record<string, number> = {
  [CycleStatus.InActive]: 0,
  [CycleStatus.Active]: 1,
  [CycleStatus.Completed]: 2,
};

export const TAB_NUMBER_TO_STATUS: Record<number, CycleStatus> = {
  0: CycleStatus.InActive,
  1: CycleStatus.Active,
  2: CycleStatus.Completed,
};
